export default "__VITE_ASSET__BMpF1zag__"